import React from "react";
import './App.css';

import AppHeader from "./components/common/header";
import AppStart from "./components/views/start";
import AppFooter from "./components/common/footer";

import { Layout, FloatButton } from "antd";
const { Header, Content, Footer } = Layout;

const App = () => {
  return (
    <Layout className="mainLayout">
      <Header style={{ paddingInline: 0, height: "auto", position: "fixed", width: "100%", zIndex: 999, top: 0 }}>
        <AppHeader />
      </Header>
      <Content style={{ paddingTop: 0 }}>
        <AppStart />
      </Content>
      <Footer>
        <AppFooter />
      </Footer>
      <FloatButton.BackTop visibilityHeight={400} />
    </Layout>
  );
};

export default App;
